/**
 * Vocabulary illustration status constants
 * Must match the constants in Core\Entity\Voc on the backend
 */

export const ILLUSTRATION_STATUS_WITHOUT_IMAGE = -1; // Will never have illustration
export const ILLUSTRATION_STATUS_NO_IMAGE = 0; // No illustration yet, but may have one
export const ILLUSTRATION_STATUS_PNG_UPLOADED = 1;
export const ILLUSTRATION_STATUS_ENHANCING = 2;
export const ILLUSTRATION_STATUS_DONE = 3; // AI enhanced with alpha (final)

/**
 * Get human-readable text for illustration status
 */
export function getIllustrationStatusText(status: number): string {
  switch (status) {
    case ILLUSTRATION_STATUS_WITHOUT_IMAGE:
      return 'Without Image';
    case ILLUSTRATION_STATUS_NO_IMAGE:
      return 'No Image';
    case ILLUSTRATION_STATUS_PNG_UPLOADED:
      return 'PNG Uploaded';
    case ILLUSTRATION_STATUS_ENHANCING:
      return 'Enhancing';
    case ILLUSTRATION_STATUS_DONE:
      return 'Done';
    default:
      return 'Unknown';
  }
}

/**
 * Check if a vocabulary item can have illustrations
 */
export function canHaveIllustration(status: number): boolean {
  return status !== ILLUSTRATION_STATUS_WITHOUT_IMAGE;
}

/**
 * Check if upload is allowed for this status
 */
export function canUploadIllustration(status: number): boolean {
  return status === ILLUSTRATION_STATUS_NO_IMAGE || status === ILLUSTRATION_STATUS_PNG_UPLOADED;
}

/**
 * Check if illustration is shared from parent synonym
 */
export function isSharedIllustration(illustration: { isShared?: boolean }): boolean {
  return illustration.isShared === true;
}

/**
 * Get the text to display for shared illustrations
 */
export function getSharedFromText(illustration: {
  isShared?: boolean;
  sharedFromTitle?: string | null;
  sharedFromId?: number | null;
}): string | null {
  if (!isSharedIllustration(illustration)) {
    return null;
  }

  if (illustration.sharedFromTitle) {
    return `Shared from: ${illustration.sharedFromTitle}`;
  }

  if (illustration.sharedFromId) {
    return `Shared from vocabulary ID: ${illustration.sharedFromId}`;
  }

  return 'Shared from parent synonym';
}
